import { render, staticRenderFns } from "./form-group.vue?vue&type=template&id=5f19a4dd&scoped=true&"
import script from "./form-group.vue?vue&type=script&lang=js&"
export * from "./form-group.vue?vue&type=script&lang=js&"
import style0 from "./form-group.vue?vue&type=style&index=0&id=5f19a4dd&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f19a4dd",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol})
